import { createVNode as a, mergeProps as n } from "vue";
import m from "../node_modules/@pf-ui/pf-icon-svg/es/asn/UserFemaleTwotoneStandard.js";
import s from "../components/PfIcon.js";
const e = (r, t) => {
  const o = {
    ...r,
    ...t.attrs
  };
  return a(s, n(o, {
    icon: m
  }), null);
};
e.displayName = "UserFemaleTwotoneStandard";
e.inheritAttrs = !1;
export {
  e as default
};
